// extracted by mini-css-extract-plugin
export var currencyInput = "_jo-1";
export var currencySymbol = "_jo-0";